import { Component, Inject, Input } from '@angular/core';
import { DATE_OPTIONS, DateOptions } from '@fgb/core';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@Component({
  selector: 'fgbcl-expired-pill',
  standalone: true,
  imports: [PipesModule, FGBSharedModule],
  templateUrl: './expired-pill.component.html',
  styleUrl: './expired-pill.component.scss',
})
export class ExpiredPillComponent {
  @Input() ExpirationDate: Date | string;

  constructor(@Inject(DATE_OPTIONS) public dateOption: DateOptions) {}
}
